import {ENDPOINT_ADMIN_EXCHANGE_ORDERS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const map = require('mn-utils/map');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequestAdmin,
} = require('../ws');


const exchangeOrders$ = new Emitter([
  {
    id: '1',
    created_date: '2020-02-17T12:07',
    status: 'expired',
    cc_src: 'ETH',
    cc_dst: 'USDC',
    exchange_name: 'Binance',
    amount: '0.00003',
    cost: '0.686225099999999921',
    cost_expected: '0',
    rate: '9002.61',
  },
  {
    id: '1',
    created_date: '2020-02-17T12:07',
    status: 'expired',
    cc_src: 'ETH',
    cc_dst: 'USDC',
    exchange_name: 'Binance',
    amount: '0.00003',
    cost: '0.686225099999999921',
    cost_expected: '0',
    rate: '9002.61',
  },
]);

export function apiAdminExchangeOrdersList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  return (() => {
    if (process.env.MOCK) {
      const items = exchangeOrders$.getValue();
      return CancelablePromise.delay(500, {
        list: items.slice(offset, offset + limit),
        count: items.length,
      });
    }
    return apiRequestAdmin(ENDPOINT_ADMIN_EXCHANGE_ORDERS_LIST, {
      ...params,
      offset,
      limit,
    });
  })().then((v) => {
    return {
      ...v,
      list: map(v.list, (v) => {
        return {
          ...v,
          pair: v.cc_src + '/' + v.cc_dst,
          time: v.created_date,
        };
      }),
    };
  });
}
